import { OrderSet } from '@exodus/models'

export const resultFunction = (orderSet) => {
  if (!orderSet || orderSet.size === 0) return OrderSet.EMPTY

  return OrderSet.fromArray([...orderSet].filter((order) => order.status === 'potential-complete'))
}

const potentialCompleteOrdersSelectorDefinition = {
  id: 'potentialCompleteOrders',
  resultFunction,
  dependencies: [{ selector: 'all' }],
}

export default potentialCompleteOrdersSelectorDefinition
